import { render } from "./NcrmHomePageHeader.vue?vue&type=template&id=ae9657e2&scoped=true"
import script from "./NcrmHomePageHeader.vue?vue&type=script&lang=js"
export * from "./NcrmHomePageHeader.vue?vue&type=script&lang=js"

import "./NcrmHomePageHeader.vue?vue&type=style&index=0&id=ae9657e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae9657e2"]])

export default __exports__